import {
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,
    USER_LOADED_REQUEST,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    SINGLE_USER_DETAILS_REQUEST,
    SINGLE_USER_DETAILS_SUCCESS,
    SINGLE_USER_DETAILS_FAIL,
    SINGLE_USER_UPDATE_REQUEST,
    SINGLE_USER_UPDATE_SUCCESS,
    SINGLE_USER_UPDATE_FAIL,
    MAKER_LIST_REQUEST,
    MAKER_LIST_SUCCESS,
    MAKER_LIST_FAIL,
    ADMIN_LIST_REQUEST,
    ADMIN_LIST_SUCCESS,
    ADMIN_LIST_FAIL,
    USER_LIST_RESET,
    MAKER_LIST_RESET,
    ADMIN_LIST_RESET,
    SINGLE_USER_DELETE_REQUEST,
    SINGLE_USER_DELETE_SUCCESS,
    SINGLE_USER_DELETE_FAIL,
    USER_REPORT_REQUEST,
    USER_REPORT_SUCCESS,
    USER_REPORT_FAIL,
    USER_REPORT_LIST_REQUEST,
    USER_REPORT_LIST_SUCCESS,
    USER_REPORT_LIST_FAIL,
    USER_SINGLE_REPORT_REQUEST,
    USER_SINGLE_REPORT_SUCCESS,
    USER_SINGLE_REPORT_FAIL,
    USER_REPORT_DELETE_REQUEST,
    USER_REPORT_DELETE_SUCCESS,
    USER_REPORT_DELETE_FAIL,
} from '../constants/AuthConstants';
import axios from 'axios';
import { server_api } from './api';

export const userLoaded = () => async (dispatch, getState) => {
    try{

        dispatch({
            type: USER_LOADED_REQUEST
        })
          
        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                Authorization : `Bearer ${info.token}`
            }
        }

        if (config) {
            const { data } = await axios.get(`${server_api}/api/auth/profile`, config)
            
            dispatch({
                type: USER_LOADED_SUCCESS,
                payload: data
            })
        }

    } catch(error){

        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }
 
        dispatch({
            type: USER_LOADED_FAIL,
            payload: message
        })
   
    }
}




export const login = (loginData) => async (dispatch, getState) => {


    try {

        dispatch({
            type: USER_LOGIN_REQUEST
        })

        

        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }

        const { data }= await axios.post(`${server_api}/api/auth/login`,loginData, config) 

        const authData = {
             token: data.token,
             role: data.data.role
       }

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: authData
        })

        
        localStorage.setItem('authInfo', JSON.stringify(authData));
        
        dispatch(userLoaded())

    } catch (error) {

        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: USER_LOGIN_FAIL,
            payload: resErr
        })
    }
}


export const register = (registerData) => async (dispatch) => {

    try {
        
        dispatch({
            type: USER_REGISTER_REQUEST
        })

        const config = {
            headers: {
                'Content-Tpye': 'application/json'
            }
        }

        const { data } = await axios.post(`${server_api}/api/auth/register`, registerData, config)

        // const authData = {
        //     token: data.token,
        //     role:  data.data.role
        // }

        dispatch({
            type: USER_REGISTER_SUCCESS,
            payload: data
        })

        // dispatch({
        //     type: USER_LOGIN_SUCCESS,
        //     payload: authData
        // })

        
        // localStorage.setItem('authInfo', JSON.stringify(authData));
        
        // dispatch(userLoaded())

    } catch (error) {

        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        
        dispatch({
            type: USER_REGISTER_FAIL,
            payload: resErr
        })
    }
}



export const logout = () => (dispatch) => {
    dispatch({ type:USER_LOGOUT })
    localStorage.removeItem('authInfo')
    localStorage.removeItem('cartItems')
    localStorage.removeItem('shippingAddress')
    localStorage.removeItem('paymentMethod')
    document.location.href = '/';
    window.location.reload();
}



export const updateProfile = (user) => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST
        })


        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.put(`${server_api}/api/auth/profile`, user, config)

        const authData = {
            token: data.token,
            role:  data.data.role
        }

        dispatch({
            type: USER_UPDATE_PROFILE_SUCCESS,
            payload: data
        })

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: authData
        })

        
        localStorage.setItem('authInfo', JSON.stringify(authData));
        
        dispatch(userLoaded())
        
    } catch (error) {
        
        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: USER_UPDATE_PROFILE_FAIL,
            payload: message,
        })
    }
    
}











// ADMIN CONTROLLER

export const getUserList = () => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: USER_LIST_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/users`, config)

        dispatch({
            type: USER_LIST_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        

        dispatch({
            type: USER_LIST_FAIL,
            payload: resErr
        })
        
    }
}




export const getMakerList = () => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: MAKER_LIST_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/makers`, config)

        dispatch({
            type: MAKER_LIST_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        

        dispatch({
            type: MAKER_LIST_FAIL,
            payload: resErr
        })
        
    }
}



export const getAdminList = () => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: ADMIN_LIST_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/admins`, config)

        dispatch({
            type: ADMIN_LIST_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        

        dispatch({
            type: ADMIN_LIST_FAIL,
            payload: resErr
        })
        
    }
}


export const getSingleUserDetails = (id) => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: SINGLE_USER_DETAILS_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/view/${id}`, config)

        dispatch({
            type: SINGLE_USER_DETAILS_SUCCESS,
            payload: data
        })

    } catch (error) {

        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: SINGLE_USER_DETAILS_FAIL,
            payload: message,
        })
        
    }
}



export const putSingleUserUpdate = (id, updateData) => async (dispatch, getState) => {

    try {
        
        dispatch({
            type:SINGLE_USER_UPDATE_REQUEST 
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        const { data } = await axios.put(`${server_api}/api/auth/update/${id}`, updateData, config)

        dispatch({
            type: SINGLE_USER_UPDATE_SUCCESS,
            payload: data
        })

        dispatch({
            type: MAKER_LIST_SUCCESS,
            payload: data
        })
        dispatch({
            type: USER_LIST_SUCCESS,
            payload: data
        })
        dispatch({
            type: ADMIN_LIST_SUCCESS,
            payload: data
        })

        dispatch({
            type: USER_LIST_RESET
        })

        dispatch({
            type: MAKER_LIST_RESET
        })

        dispatch({
            type: ADMIN_LIST_RESET
        })

        



    } catch (error) {

        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: SINGLE_USER_UPDATE_FAIL,
            payload: message,
        })
        
    }
}




export const deleteUser = (id) => async (dispatch, getState) => {

    try {
        
        dispatch({
            type:SINGLE_USER_DELETE_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }

        await axios.delete(`${server_api}/api/auth/delete/${id}`, config)

        dispatch({
            type: SINGLE_USER_DELETE_SUCCESS
        })

    } catch (error) {

        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: SINGLE_USER_DELETE_FAIL,
            payload: message,
        })
        
    }
}




export const postUserReports = (reportData) => async (dispatch) => {

    try {

        dispatch({
            type: USER_REPORT_REQUEST
        })

        const config = {
            headers: {
                'Content-Tpye': 'application/json'
            }
        }

       const { data } =  await axios.post(`${server_api}/api/auth/report`, reportData, config)


        dispatch({
            type: USER_REPORT_SUCCESS,
            payload: data
        })

    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: USER_REPORT_FAIL,
            payload: resErr
        })
    }
}


export const getUserReportList = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_REPORT_LIST_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/report`, config)

        dispatch({
            type: USER_REPORT_LIST_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: USER_REPORT_LIST_FAIL,
            payload: resErr
        })

    }
}



export const getUserReportOne = (id) => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_SINGLE_REPORT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/auth/report/${id}`, config)

        dispatch({
            type: USER_SINGLE_REPORT_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: USER_SINGLE_REPORT_FAIL,
            payload: resErr
        })

    }
}


export const getUserReportDelete = (id) => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_REPORT_DELETE_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.delete(`${server_api}/api/auth/report/${id}`, config)

        dispatch({
            type: USER_REPORT_DELETE_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: USER_REPORT_DELETE_FAIL,
            payload: resErr
        })

    }
}